import React from 'react';
import { Calendar, Clock, Eye, AlertTriangle, FileText, User } from 'lucide-react';

const ComunicacaoCard = ({ comunicacao, prazoRelacionado, onMarcarComoVista, onVerDetalhes }) => {
  
  // Determinar o tipo e urgência da comunicação
  const temPrazo = comunicacao.temPrazo || prazoRelacionado;
  const urgencia = prazoRelacionado?.urgencia || 'normal';
  const foiVista = comunicacao.isRead;

  // Cores baseadas na urgência e tipo
  const getCardStyle = () => {
    if (temPrazo) {
      switch (urgencia) {
        case 'vencido':
          return 'border-l-4 border-l-red-600 bg-red-50/80';
        case 'hoje':
          return 'border-l-4 border-l-red-500 bg-red-50/60';
        case 'esta_semana':
          return 'border-l-4 border-l-amber-500 bg-amber-50/60';
        default:
          return 'border-l-4 border-l-blue-500 bg-blue-50/40';
      }
    } else {
      return foiVista 
        ? 'border-l-4 border-l-gray-300 bg-gray-50/60' 
        : 'border-l-4 border-l-blue-400 bg-white';
    }
  };

  const getUrgencyBadge = () => {
    if (!temPrazo) return null;
    
    switch (urgencia) {
      case 'vencido':
        return <span className="px-2 py-1 text-xs font-bold bg-red-600 text-white rounded-full">VENCIDO</span>;
      case 'hoje':
        return <span className="px-2 py-1 text-xs font-bold bg-red-500 text-white rounded-full">HOJE</span>;
      case 'esta_semana':
        return <span className="px-2 py-1 text-xs font-bold bg-amber-500 text-white rounded-full">ESTA SEMANA</span>;
      default:
        return <span className="px-2 py-1 text-xs font-bold bg-blue-500 text-white rounded-full">PRAZO</span>;
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Data não informada';
    try {
      return new Date(dateString).toLocaleDateString('pt-BR');
    } catch {
      return 'Data inválida';
    }
  };

  return (
    <>
      <div className={`bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 p-6 ${getCardStyle()}`}>
      {/* Header com ícone e status */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          {temPrazo ? (
            <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
              <AlertTriangle className="w-5 h-5 text-red-600" />
            </div>
          ) : (
            <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
              <FileText className="w-5 h-5 text-blue-600" />
          </div>
          )}
          <div>
            <h3 className="font-bold text-gray-900 text-sm">
              {comunicacao.assunto || 'Comunicação'}
            </h3>
            {getUrgencyBadge()}
          </div>
        </div>

        {!foiVista && (
          <div className="w-3 h-3 bg-blue-500 rounded-full animate-pulse" title="Não vista"></div>
        )}
          </div>

      {/* Número do processo */}
      <div className="mb-3">
        <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">
          Processo
        </p>
        <p className="text-sm font-semibold text-gray-900 truncate">
          {comunicacao.numeroProcesso || 'Não informado'}
        </p>
          </div>

      {/* Conteúdo resumido */}
      <div className="mb-4">
        <p className="text-sm text-gray-600 line-clamp-3 leading-relaxed">
          {comunicacao.conteudo || 'Conteúdo da comunicação não disponível'}
        </p>
        {comunicacao.conteudo && (
          <div className="text-xs text-blue-600 mt-2 font-medium">
            💡 Clique em "Ver Detalhes" para ler o conteúdo completo
          </div>
                  )}
                </div>

      {/* Data */}
      <div className="mb-4 text-xs text-gray-500">
        <div className="flex items-center gap-1">
          <Calendar className="w-3 h-3" />
          <span>{formatDate(comunicacao.dataRecebimento || comunicacao.createdAt)}</span>
        </div>
        </div>

      {/* Ações - Estilo similar aos prazos */}
      <div className="flex items-center gap-2">
              <button
          onClick={onVerDetalhes}
          className="flex-1 px-3 py-2 text-xs font-semibold text-blue-700 bg-blue-50 hover:bg-blue-100 rounded-lg transition-all duration-200 transform hover:scale-105"
              >
          📄 Ver Detalhes
              </button>

        {!foiVista && (
              <button
            onClick={onMarcarComoVista}
            className="px-3 py-2 text-xs font-semibold text-green-700 bg-green-50 hover:bg-green-100 rounded-lg transition-all duration-200 transform hover:scale-105 flex items-center gap-1"
          >
            <Eye className="w-3 h-3" />
            ✅ Visto
              </button>
        )}
      </div>
    </div>
    </>
  );
};

export default ComunicacaoCard;